<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 22 19">
    <g clip-path="url(#clip0_6892_9088)">
      <path
        d="M18.9234 2.46606H1.8313C0.81798 2.46606 0 3.30531 0 4.34498V16.8711C0 17.9107 0.81798 18.75 1.8313 18.75H18.9234C19.9367 18.75 20.7547 17.9107 20.7547 16.8711V4.34498C20.7547 3.30531 19.9367 2.46606 18.9234 2.46606ZM19.5339 16.8711C19.5339 17.2093 19.2653 17.4974 18.9234 17.4974H1.8313C1.48946 17.4974 1.22087 17.2093 1.22087 16.8711V9.98172H19.5339V16.8711ZM1.22087 6.22389V4.34498C1.22087 3.99425 1.48946 3.71867 1.8313 3.71867H18.9234C19.2653 3.71867 19.5339 3.99425 19.5339 4.34498V6.22389H1.22087Z"
        :class="colorClass"
      />
      <path
        d="M21.7778 5.25C21.7778 7.73528 19.7631 9.75 17.2778 9.75C14.7926 9.75 12.7778 7.73528 12.7778 5.25C12.7778 2.76472 14.7926 0.75 17.2778 0.75C19.7631 0.75 21.7778 2.76472 21.7778 5.25Z"
        fill="#11B121"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.8707 3.59467C20.1636 3.88756 20.1636 4.36244 19.8707 4.65533L17.2457 7.28033C16.9528 7.57322 16.4779 7.57322 16.185 7.28033L14.685 5.78033C14.3921 5.48744 14.3921 5.01256 14.685 4.71967C14.9779 4.42678 15.4528 4.42678 15.7457 4.71967L16.7153 5.68934L18.81 3.59467C19.1029 3.30178 19.5778 3.30178 19.8707 3.59467Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9088">
        <rect width="22" height="18" fill="white" transform="translate(0 0.75)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
